// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1__0M","cls2":"SearchBar-cls2_Y9n SearchBar-cls1__0M"};